import React, { useState } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import PickerSelect from '../components/PickerSelect';
import InputForm from '../components/InputForm';
import { openAlert } from '../store/actions/alert';
import { useDispatch } from 'react-redux';
import BaseText from '../components/BaseText';
import { sendContactEmail } from '../services/contact.service';
import { Color, CommonProperties } from '../styles';
import BottomButton from '../components/BottomButton';
import { Screens } from '../constants/ScreenNames';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
const ContactScreen = (props) => {
  const { t } = useTranslation(i18nNS.contacts);
  const { tKey } = useComponentTKey('ContactScreen');
  const [contactDepartment, setContactDepartment] = useState('');
  const [annualValue, setAnnualValue] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');
  const [hqName, setHqName] = useState('');
  const dispatch = useDispatch();

  const submitForm = async () => {
    setLoading(true);
    const emailResponce = await sendContactEmail({
      Company: companyName,
      Subject: contactDepartment,
      cemail: contactEmail,
      cname: hqName,
      cphone: phone,
      contactname: contactName,
      csubject: annualValue,
      cquestion: comment,
    });
    if (emailResponce.Company) {
      setLoading(false);
      dispatch(
        openAlert({
          title: t(tKey('ThankYou')),
          onConfirmPressed: () => {
            props.navigation.navigate(Screens.Home);
          },
        })
      );
    } else {
      setLoading(false);
      dispatch(openAlert({ title: t(tKey('FormSubmissionFailed')) }));
    }
  };

  const dropDownKeysValues = [
    {
      label: t(tKey('CorporateSales')),
      value: 'Corporate Sales',
    },
    {
      label: t(tKey('ProductSupport')),
      value: 'Product Support',
    },
    {
      label: t(tKey('AccountManagement')),
      value: 'Account Management',
    },
    {
      label: t(tKey('Accounting')),
      value: 'Accounting',
    },
    {
      label: t(tKey('TravelReservations')),
      value: 'Travel Reservations',
    },
    {
      label: t(tKey('Advertising')),
      value: 'Advertising',
    },
    {
      label: t(tKey('Press')),
      value: 'Press',
    },
    {
      label: t(tKey('JobPosting')),
      value: 'Job Posting',
    },
  ];
  const annualTravelOptions = [
    {
      label: t(tKey('TripDirect')),
      value: 'TripDirect',
    },
    {
      label: t(tKey('TripEvents')),
      value: 'TripEvents',
    },
    {
      label: t(tKey('TripGuest')),
      value: 'TripGuest',
    },
    {
      label: t(tKey('TripRobot')),
      value: 'TripRobot',
    },
    {
      label: t(tKey('TripApproval')),
      value: 'TripApproval',
    },
    {
      label: t(tKey('TripAudit')),
      value: 'TripAudit',
    },
    {
      label: t(tKey('TripSecurity')),
      value: 'TripSecurity',
    },
    {
      label: t(tKey('TripData')),
      value: 'TripData',
    },
    {
      label: 'TripBank',
      value: 'TripBank',
    },
  ];
  return (
    <ScrollView style={styles.container}>
      <View style={styles.body}>
        <BaseText>{t(tKey('WhoToContact'))}</BaseText>
        <PickerSelect
          onValueChange={(value) => {
            setContactDepartment(value);
          }}
          items={dropDownKeysValues}
          value={contactDepartment}
          placeholder={{ label: t(tKey('PleaseSelectOne')) }}
        />
        <InputForm label={t(tKey('Company'))} value={companyName} onChangeText={setCompanyName} />
        <InputForm label={t(tKey('UserName'))} value={hqName} onChangeText={setHqName} />
        <InputForm
          label={t(tKey('ContactName'))}
          value={contactName}
          onChangeText={setContactName}
        />
        <InputForm
          label={t(tKey('ContactEmail'))}
          value={contactEmail}
          onChangeText={setContactEmail}
        />
        <InputForm label={t(tKey('Phone'))} value={phone} onChangeText={setPhone} />
        <BaseText>{t(tKey('Product'))}</BaseText>
        <PickerSelect
          onValueChange={(value) => {
            setAnnualValue(value);
          }}
          items={annualTravelOptions}
          value={annualValue}
          placeholder={{ label: t(tKey('PleaseSelectOne')) }}
        />
        <InputForm label={t(tKey('QueryMessage'))} value={comment} onChangeText={setComment} />
      </View>
      <BottomButton loading={loading} label={t(tKey('Submit'))} onPress={submitForm} />
    </ScrollView>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.accent,
  },
  body: {
    flex: 1,
    ...CommonProperties.p3,
  },
});

export default ContactScreen;
